import { Box, Container } from '@mui/material'
import { StowageInstructionHeader } from '@storage/features/stowage-instruction/components/molecules/StowageInstructionHeader'
import { StowageInstructionTable } from '@storage/features/stowage-instruction/components/organisms/StowageInstructionTable'
import { useStorageStore } from '@storage/index'
import { useMinimalsTheme } from '@tom-ui/ui'
import { useAsyncFetch, withAuthenticationRequired } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'

const StowageInstructionPage = withAuthenticationRequired(
  observer(() => {
    const theme = useMinimalsTheme()
    const { stowageInstructionStore } = useStorageStore()
    useAsyncFetch(() => stowageInstructionStore.fetchData(), [stowageInstructionStore])

    return (
      <Box
        sx={{
          bgcolor: theme.palette.grey[100],
          minHeight: '100%',
        }}
      >
        <StowageInstructionHeader />
        <Container sx={{ paddingY: theme.customSpacing.m }} data-cy='stowage-instruction-table'>
          <StowageInstructionTable store={stowageInstructionStore} />
        </Container>
      </Box>
    )
  }),
)

export default StowageInstructionPage
